// const BASE_URL = "https://localhost:7231/api/Salary";

import { BASE_URL } from "../config";


export const processSalary = async (salaryData) => {
  try {
    const response = await fetch(`${BASE_URL}/Salary/process`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(salaryData)
    });

    const result = await response.json();

    if (!response.ok) {
      throw new Error(result.message || "Failed to process salary");
    }

    console.log("Success:", result);
    return result;

  } catch (error) {
    console.error("Error processing salary:", error);
    throw error;
  }
};


export const getSalaryRegister = async (filters) => {
  try {
    const response = await fetch(`${BASE_URL}/Salary/get-salary-register`, {
      method: "POST",  // Change from GET to POST
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(filters), // Pass month, year, departmentId, sectionId
    });

    if (!response.ok) {
      throw new Error("Please check attendance is add or not to get salary register");
    }

    // return await response.json();
    const data = await response.json();

    // 👇 Print data on console
    console.log("Salary Register Data:", data);
    return data;
  } catch (error) {
    console.error("Error fetching salary register:", error);
    throw error;
  }
};


export const getSalarySlipForEmployee = async (employeeCode, month, year) => {
  const response = await fetch(
    `${BASE_URL}/Salary/slip/${employeeCode}/${month}/${year}`
  );
  if (!response.ok) throw new Error("Failed to fetch salary slip");
  return await response.json();
};